import React from 'react'
import AlertCard from './AlertCard'
import AlertTemplateCard from './AlertTemplateCard'
import { Box, CircularProgress, Typography } from '@mui/material'
import { useAlertContext } from '../contexts/AlertContext'

function AlertCardList() {
  const { filteredAlerts, searchTerm, loading, error, templateCards, templateCardsLoading } =
    useAlertContext()

  // With no alerts to show yet, wait for the template offer too — otherwise a member with no
  // alerts sees "No Alerts found" right before the cards it contradicts.
  if (loading || (filteredAlerts.length === 0 && templateCardsLoading)) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    )
  }

  /* Show message if there is nothing at all to show — template cards count */
  if (filteredAlerts.length === 0 && templateCards.length === 0) {
    return (
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width={'100%'}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
          <Typography variant="h5" color={'textSecondary'} fontWeight={'normal'}>
            No Alerts found
          </Typography>
          <Typography variant={'body1'} color={'textSecondary'} textAlign={'center'}>
            {searchTerm.trim()
              ? 'Try adjusting your filters.'
              : "Create an alert to get notifications when your pattern's rules are met."}
          </Typography>
        </Box>
      </Box>
    )
  }

  return (
    <Box
      id="alert-card-list-container"
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#1A1B1E',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#383B42',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#4A4D55',
        },
      }}
    >
      {/* Error message if any */}
      {error && (
        <Box
          sx={{
            color: 'error.main',
            p: 2,
            backgroundColor: 'rgba(244, 67, 54, 0.08)',
            borderRadius: 2,
            mb: 2,
            border: '1px solid rgba(244, 67, 54, 0.2)',
          }}
        >
          {error.message}
        </Box>
      )}

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
          gap: 1,
        }}
      >
        {filteredAlerts.map((alert) => (
          <AlertCard key={alert.id} alert={alert} />
        ))}

        {/* Templates the member has no alert from yet. Rendered after their own alerts so
            the tour's first-card selectors keep resolving to a real alert card. */}
        {templateCards.map((template) => (
          <AlertTemplateCard key={template.id} template={template} />
        ))}
      </Box>
    </Box>
  )
}

export default AlertCardList
